<template>
  <div class="row">
    <span class="col"><b>{{this.kkey}}</b></span>
    <span class="col">{{this.vvalue}}</span>
  </div>
</template>

<script>
export default {


  props: {
    kkey: '',
    vvalue: ''
  },


}
</script>
